import { ReactNode } from "react";

export let pluginComponents = {};

type PluginModule = {
    components: Record<string, ReactNode>,
}

export const loadPlugin = async (pluginPath: string) => {
    try {
        const pluginModule: PluginModule = await import(/* @vite-ignore */ pluginPath);

        pluginComponents = {...pluginComponents, ...pluginModule.components};

        console.info(`Loaded plugin: ${pluginPath}`, pluginModule);
    }
    catch (err) {
        console.error(`Failed to load plugin: ${pluginPath}`, err);
    }
}